import React, { useEffect, useState } from 'react'
import { Edit, HelpCircle, Menu, MessageSquare, PanelLeft, PanelLeftClose, Plus, Save, Search, Settings, Trash2, X } from 'lucide-react';
import Button from './Button';
import Input from './Input';
import Help from '../constant/help';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';
import ReactMarkdown from 'react-markdown';
import removeMd from 'remove-markdown';

export default function Sidebar(props) {

    const {handleNewChat, conversationList, handleSelectConversation, setSelectedFileForChat, handleDeleteChatConversation, handleEditChatTitle, currentChatId, showSidebar, setShowSidebar, configChatweb, desktopSidebarCollapsed, setDesktopSidebarCollapsed} = props

    const { t } = useTranslation();

    const sidebarCollapsed = desktopSidebarCollapsed;

    const [conversationSearchQuery, setConversationSearchQuery] = useState("")

    const [editingChatId, setEditingChatId] = useState(null);
    const [editingChatTitle, setEditingChatTitle] = useState("");

    const [showConvConfirm, setShowConvConfirm] = useState(false);
    const [selectedConvIdToDelete, setSelectedConvIdToDelete] = useState(null);

    const getFilteredConversations = () => {
        let filtered = conversationList;

        if (conversationSearchQuery.trim()) {
            const keyword = conversationSearchQuery.toLowerCase();
            filtered = filtered.filter((conv) => (conv.firstMessage || "").toLowerCase().includes(keyword));
        }
        return filtered; 
    };

    useEffect(() => {
        setEditingChatId(null);
        setEditingChatTitle("");
    }, [currentChatId]);

    return (
        <div
            className={`w-full bg-white border-r border-gray-200 flex flex-col h-full mx-auto overflow-hidden`}
        >

            <div className="flex-shrink-0">
                {/* Header với background */}
                <div className="bg-gradient-to-r from-sky-500 to-blue-600 text-white p-4" style={{height: '80px'}}>
                    <div
                        className={`flex items-center ${
                            !sidebarCollapsed ? "" : "justify-center"
                        }`}
                        >
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => {
                                if (showSidebar) {
                                // Nếu đang mở dạng drawer (mobile) → đóng lại
                                setShowSidebar(false);
                                } else {
                                // Ngược lại → toggle collapse trên desktop
                                if(setDesktopSidebarCollapsed) setDesktopSidebarCollapsed(!desktopSidebarCollapsed);
                                }
                            }}
                            className="h-7 w-7 p-0 text-white hover:text-sky-100 hover:bg-sky-600 [&_svg]:h-5 [&_svg]:w-5"
                        >
                            <Menu className="h-5 w-5" />
                        </Button>
                        {!sidebarCollapsed ? (
                        <div className="flex items-center space-x-3 ml-3">
                            {/* <div className="w-8 h-8 bg-white rounded-lg p-1.5 shadow-sm">
                                {configChatweb?.avatarUrl ? (
                                    <img src={configChatweb.avatarUrl} className="w-full h-full object-contain" />
                                ) : (
                                    <img src="/vietrade-official-logo.png" alt="Vietrade" className="w-full h-full object-contain" />
                                )}
                            </div> */}
                            <div>
                                <span className="font-bold text-white text-sm">
                                    {configChatweb?.botName && configChatweb.botName.trim() !== ''
                                    ? configChatweb.botName
                                    : 'VietradeAI'}
                                </span>
                                <p className="text-xs text-sky-100 leading-tight">
                                    {configChatweb?.desription && configChatweb.desription.trim() !== ''
                                    ? (configChatweb.desription).toUpperCase()
                                    : t('sidebar.title_description')}
                                </p>
                            </div>
                        </div>
                        ) : (
                        <></>
                        )
                        }
                        
                    </div>
                </div>

                {/* New chat  */}
                <div className="p-4 border-b border-gray-200">
                    {!sidebarCollapsed ? (
                        <Button
                            onClick={() => {
                                handleNewChat();

                                // 👉 Nếu đang ở mobile drawer thì đóng sidebar
                                if (showSidebar) {
                                setShowSidebar(false);
                                }
                            }}
                            className="w-full bg-sky-500 hover:bg-sky-600 text-white rounded-lg h-10 flex items-center justify-center space-x-2"
                        >
                            <Plus className="h-4 w-4" />
                            <span className="text-sm font-medium">{t('sidebar.manage_conversation.create_new_conversation')}</span>
                        </Button>
                    ) : (
                        <Button
                            variant="ghost"
                            onClick={handleNewChat}
                            className="w-10 h-10 mx-auto text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg flex items-center justify-center"
                            title={t('sidebar.manage_conversation.create_new_conversation')}
                        >
                            <Edit className="h-5 w-5" />
                        </Button>
                    )}
                </div>

                {!sidebarCollapsed && (
                /* Expanded Sidebar - Full Chat History */
                <>
                    {/* Chat Search */}
                    {conversationList.length > 0 && (
                        <div className="p-4 border-b border-gray-200">
                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                                <Input
                                    value={conversationSearchQuery}
                                    onChange={(e) => setConversationSearchQuery(e.target.value)}
                                    placeholder={t('sidebar.manage_conversation.search_conversation')}
                                    className="pl-9 h-9 rounded-md text-sm border-gray-300 focus:border-sky-400"
                                />
                            </div>
                        </div>
                    )}
                </>
                )}
            </div>
            
            {/* Chat History */}
            {sidebarCollapsed ? (
                <div className="flex-1" />
            ) : (
            <div className="flex-1 overflow-y-auto overscroll-contain">
                    <div className="p-4">
                        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                            {t('sidebar.manage_conversation.history_conversation')}
                        </h3>

                        {getFilteredConversations().length === 0 ? (
                            <div className="text-center py-8">
                                <MessageSquare className="h-8 w-8 text-gray-300 mx-auto mb-2" />
                                <p className="text-xs text-gray-500">
                                {conversationSearchQuery.trim()
                                    ? t('sidebar.manage_conversation.not_found_conversation')
                                    : t('sidebar.manage_conversation.no_conversations')
                                    }
                                </p>
                            </div>
                            ) : (
                            <div className="space-y-2">
                                {getFilteredConversations().map((session) => (
                                <div
                                    key={session.id}
                                    onClick={() => {
                                        if (editingChatId !== null && editingChatId !== session.id) {
                                           setEditingChatId(null);
                                           setEditingChatTitle("");
                                        }
                                        handleSelectConversation(session.id);
                                        if (showSidebar) {
                                            setShowSidebar(false);
                                        }
                                    }}
                                    className={`group p-3 rounded-lg cursor-pointer transition-colors relative ${ currentChatId === session.id ? "bg-sky-100 border border-sky-200" : "hover:bg-gray-100 border border-transparent"}`}
                                >
                                    {editingChatId === session.id ? (
                                    <div className="space-y-2">
                                        <Input
                                        value={editingChatTitle}
                                        onChange={(e) => setEditingChatTitle(e.target.value)}
                                        className="text-sm h-8"
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleEditChatTitle(session.id, editingChatTitle)
                                                setEditingChatId(null);
                                            } else if (e.key === "Escape") {
                                                setEditingChatId(null);
                                            }
                                        }}
                                        autoFocus
                                        />
                                        <div className="flex space-x-1">
                                        <Button
                                            size="sm"
                                            onClick={() => 
                                                {
                                                    handleEditChatTitle(session.id, editingChatTitle); 
                                                    setEditingChatId(null)
                                                }
                                            }
                                            className="h-6 text-xs bg-sky-500 hover:bg-sky-600 text-white"
                                        >
                                            <Save className="h-3 w-3" />
                                        </Button>
                                        <Button
                                            size="sm"
                                            variant="outline"
                                            onClick={() => setEditingChatId(null)}
                                            className="h-6 text-xs"
                                        >
                                            <X className="h-3 w-3" />
                                        </Button>
                                        </div>
                                    </div>
                                    ) : (
                                    <div 
                                        // onClick={() => handleLoadChatSession(session)}
                                    >
                                        <div className="flex items-start justify-between">
                                        <div className="flex-1 min-w-0">
                                            <h4 className="text-sm font-medium text-gray-800 truncate mb-1">{session.firstMessage}</h4>
                                            <div className="text-xs text-gray-500 line-clamp-2 mb-1">
                                                {removeMd(Help.formatMessage(session.firstReplyMessage) || "")}
                                                </div>
                                            <div className="flex items-center space-x-2">
                                            <span className="text-xs text-gray-400">
                                                {Help.formatCreatedAt(session.createdAt)}
                                            </span>
                                            </div>
                                    </div>

                                    <div className="flex items-center space-x-1 opacity-0 group-hover:opacity-100transition-opacity">
                                        <Button
                                            variant="ghost" 
                                            size="sm"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setEditingChatId(session.id);
                                                setEditingChatTitle(session.firstMessage || "");
                                            }}
                                            className="h-6 w-6 p-0 text-gray-400 hover:text-blue-600"
                                            title={t('sidebar.manage_conversation.edit_title')}
                                        >
                                            <Edit className="h-3 w-3" />
                                        </Button>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedConvIdToDelete(session.id)
                                                setShowConvConfirm(true);
                                                // handleDeleteChatConversation(session.id)
                                            }}
                                            className="h-6 w-6 p-0 text-gray-400 hover:text-red-600"
                                            title={t('sidebar.manage_conversation.delete')}
                                        >
                                            <Trash2 className="h-3 w-3" />
                                           </Button>
                                    </div>
                                    </div>
                                </div> 
                                )}
                            </div>
                            ))}
                        </div>
                    )}
                    <ConfirmDialog
                        open={showConvConfirm}
                        title={t('sidebar.manage_conversation.confirm_delete_conv.title')}
                        message={t('sidebar.manage_conversation.confirm_delete_conv.message')}
                        onCancel={() => {
                            setShowConvConfirm(false)
                            setSelectedConvIdToDelete(null)
                        }}
                        onConfirm={() => {
                            handleDeleteChatConversation(selectedConvIdToDelete)
                            setSelectedConvIdToDelete(null)
                        }}
                    />
                </div>
            </div>
            )}
                

            {/* Bottom Section - Support Info */}
            <div className="mt-auto border-t border-gray-200 bg-white h-[115px]">
                {!sidebarCollapsed ? (
                    <div className="px-4 py-2 flex flex-col justify-center h-full">
                        <button className="flex items-center w-full justify-start text-gray-700 hover:bg-gray-100 h-8 px-3 mb-1 font-medium rounded-md text-sm">
                            <Settings className="h-4 w-4 mr-3 text-gray-500" />
                            <span className="text-sm">{t('sidebar.setting')}</span>
                        </button>

                        <div className="text-center space-y-0.5 pt-1 border-t border-gray-100 overflow-hidden">
                            <p className="text-xs text-gray-600 font-medium truncate">
                            {t('sidebar.more_info_1')}
                            </p>
                            <p className="text-xs text-sky-600 font-semibold truncate">
                                
                                {/* VietradeAI - Vietrade.gov.vn */}
                                {configChatweb?.botName && configChatweb.botName.trim() !== ''
                                ? configChatweb.botName
                                : 'VietradeAI'}{" - "}
                                {configChatweb?.domains && configChatweb?.domains?.length !== 0
                                ?  configChatweb.domains[0]
                                : 'Vietrade.gov.vn'}
                            </p>
                            <p className="text-xs text-gray-500 truncate">
                                {t('sidebar.more_info_2')}  {': '} 
                                <span className="font-medium text-gray-700"> 
                                    {configChatweb?.phone && configChatweb?.phone.trim() !== ''
                                    ? configChatweb.phone
                                    : '+84 24 3934 2020'}
                                </span>
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="py-4 flex flex-col items-center">
                        <Button
                            variant="ghost"
                            className="w-10 h-10 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg flex items-center justify-center"
                            title={t('sidebar.setting')}
                        >
                            <Settings className="h-5 w-5" />
                        </Button>
                    </div>
                )}
            </div>

        </div>
    )
}
